"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalEventType = void 0;
var SignalEventType;
(function (SignalEventType) {
    SignalEventType["PING"] = "PING";
    SignalEventType["PONG"] = "PONG";
    SignalEventType["TRANSACTION_HASH"] = "TRANSACTION_HASH";
})(SignalEventType || (exports.SignalEventType = SignalEventType = {}));
//# sourceMappingURL=signal.js.map